import { handleActions } from 'redux-actions';

import _cloneDeep from 'lodash/cloneDeep';
import _keys from 'lodash/keys';
import _omit from 'lodash/omit';

import endpoints from '../../../../config/endpoints';
import http from '../../../shared/http';
import { createKey } from '../../shared/utils';

const FETCH_CHAINS_SUCCESS = 'chain-list/fetch-data-success';
const FETCH_CHAINS_ERROR = 'chain-list/fetch-data-error';
const CLOSE_OFFER = 'chain-list/open-offer';
const FETCH_ERROR = 'chain-list/toggle-error';
const CHANGE_PAGINATION = 'chain-list/change-pagination';
const REQUEST_ACCESS = 'chain-list/request-access';
const CLOSE_RULES = 'chain-list/close-rules';

const DEFAULT_PAGINATION_CHAIN = 4;

const initialState = {
	data: {},
	pagination: {},
	error: false,
	modalData: {
		isOpen: false,
		offer: {},
		chain: {}
	},
	chainHeaderTitles: [
		{
			id: 'id',
			title: '№'
		},
		{
			id: 'title',
			title: 'Связка и описание'
		},
		{
			id: 'source',
			title: ''
		}
	],
	columns: [
		{
			id: 'title',
			title: 'Офферы',
			sortable: true
		},
		{
			id: 'ruble',
			title: 'Выпл.',
			currency: '₽',
			sortable: false
		},
		{
			id: 'dollar',
			title: 'Выпл.',
			currency: '$',
			sortable: false
		},
		{
			id: 'onsite',
			title: 'На сайте',
			sortable: false
		}
	]
};

export const actions = Object.assign({

	toggleOffer: ({ id,  chain_ids }) => (dispatch, getState) => {
		const state = getState();
		const key = createKey(id, chain_ids);
		if (state.chainList.data[key]) {
			return dispatch({ type: CLOSE_OFFER, payload: key });
		}
		return fetchRequest(dispatch, getState, chain_ids, id);
	},

	checkIsOpened: (id, chain_ids) => (dispatch, getState) => {
		const keys = _keys(getState().chainList.data);
		return keys.includes(createKey(id, chain_ids));
	},

	changePagination: (key, currentPagination) => ({
		type: CHANGE_PAGINATION,
		payload: { key, currentPagination }
	}),

	requestAccess: (chain, offer) => ({
		type: REQUEST_ACCESS,
		payload: { chain, offer }
	}),

	closeRules: () => ({
		type: CLOSE_RULES
	})

});

const reducers = Object.assign({
	[FETCH_CHAINS_SUCCESS]: (state, action) => {
		const chains = action.payload.data;
		const { key } = action.payload.mixinData;
		const data = { ...state.data, [key]: chains};
		const pagination = { ...state.pagination, [key]: DEFAULT_PAGINATION_CHAIN };
		return { ...state, data, pagination, error: false };
	},

	[FETCH_CHAINS_ERROR]: state => ({
		...state, data: null, error: true
	}),

	[FETCH_ERROR]: state => {
		return { ...state, error: true };
	},

	[CLOSE_OFFER]: (state, action) => {
		const key = action.payload;
		return { ...state, data: _omit(state.data, [key]) };
	},

	[CHANGE_PAGINATION]: (state, action) => {
		const { key, currentPagination } = action.payload;
		const pagination = { ...state.pagination, [key]: currentPagination + DEFAULT_PAGINATION_CHAIN };
		return { ...state, pagination };
	},

	[REQUEST_ACCESS]: (state, action) => {
		const { chain, offer } = action.payload;
		const modalData = { isOpen: true, chain, offer };
		return { ...state, modalData };
	},

	[CLOSE_RULES]: state => {
		const modalData = { ...state.modalData, isOpen: false };
		return { ...state, modalData };
	}

});

export default handleActions(reducers, _cloneDeep(initialState));

export const selectors = {
	getData: state => state.chainList.data,
	getColumns: state => state.chainList.columns,
	toggleOffer: state => state.chainList.toggleOffer,
	checkIsOpened: state => state.chainList.checkIsOpened,
	getChainHeaderTitles: state => state.chainList.chainHeaderTitles,
	getUser: state => state.app.userData.general,
	getPagination: state => state.chainList.pagination,
	changePagination: state => state.chainList.changePagination,
	getError: state => state.chainList.error,
	requestAccess: state => state.chainList.requestAccess,
	getModalData: state => state.chainList.modalData,
	closeRules: state => state.chainList.closeRules,
	addOffer: state => state.chains.addOffer
};

const fetchRequest = (dispatch, getState, chain_ids, id) => {
	const request = http({
		url: `${endpoints.STATISTICS.CHAINS.LIST}/${chain_ids}`,
		method: 'get',
		actions: [FETCH_CHAINS_SUCCESS, FETCH_CHAINS_ERROR],
		addToResponse: { key: createKey(id, chain_ids) }
	});

	return request(dispatch);
};



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/statistics/components/offers/index.js